import React, { useEffect, useState } from 'react';
import { Box, Collapse, Grid } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import ConsentSelector from '~/components/BillingEligibility/ConsentSelector';
import { RpmNoConsentLayout, RpmOptInLayout, RpmOptOutLayout } from '~/components/consent/RpmConsentLayouts';
import { CptCodeChip } from './CptCodeChip';
import { ConsentHelpIcon } from './ConsentHelpIcon';
export const RpmConsentSection = (props) => {
    const { patient, consentMethod, consentDate, consentNotes, optOutReason, optOutDate, optOutNotes } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [selection, setSelection] = useState('');
    const [rpmFormData, setRpmFormData] = useState(null);
    useEffect(() => {
        let initialSelection = '';
        console.log('Patient: ', patient);
        if (patient.rpmConsent) {
            initialSelection = 'opt-in';
            console.log('rpm consent true');
        }
        if (!patient.rpmConsent && patient.rpmConsentedAt !== null) {
            initialSelection = 'opt-out';
            console.log('rpm consent false and rpmconsented at not null');
        }
        if (!patient.rpmConsent && (patient.rpmConsentedAt === null || patient.rpmConsentedAt === '')) {
            initialSelection = 'no-consent';
            console.log('rpm consent false and rpmconsented at is null or empty string');
        }
        console.log(initialSelection);
        setSelection(initialSelection);
        props.onRpmDataChange(initialSelection, null);
    }, []);
    const handleSelectionChange = (newSelection) => {
        setSelection(newSelection);
        props.onRpmDataChange(newSelection, rpmFormData);
    };
    const handleFormDataChange = (data) => {
        setRpmFormData(data);
        // Notify parent of form data change
        props.onRpmDataChange(selection, data);
    };
    return (React.createElement(Box, { sx: { marginBottom: 2 } },
        React.createElement(Box, { sx: {
                backgroundColor: '#F5F5F5',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
                borderRadius: isOpen ? '8px 8px 0 0' : '8px',
                transition: 'border-radius 0.2s ease',
            } },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 8, sx: { display: 'block', alignItems: 'left', gap: 1 }, onClick: () => setIsOpen(!isOpen) },
                    React.createElement("div", { className: 'flex' },
                        React.createElement(ExpandMore, { sx: {
                                transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                                transition: 'transform 0.2s ease',
                                color: isOpen ? '#4CAF50' : '#0000008F',
                            } }),
                        React.createElement(Box, { sx: {
                                fontFamily: 'Barlow',
                                fontSize: '16px',
                                fontWeight: 500,
                                color: '#1F2937',
                                display: 'flex'
                            } },
                            "Remote Patient Monitoring (RPM) ",
                            React.createElement(ConsentHelpIcon, { program: 'RPM' }))),
                    React.createElement("div", { className: 'flex gap-2' },
                        React.createElement(CptCodeChip, { code: '99445' }),
                        React.createElement(CptCodeChip, { code: '99454' }),
                        React.createElement(CptCodeChip, { code: '99470' }),
                        React.createElement(CptCodeChip, { code: '99457' }),
                        React.createElement(CptCodeChip, { code: '99458' }))),
                React.createElement(Grid, { item: true, xs: 4, style: { marginTop: 'auto', marginBottom: 'auto' } },
                    React.createElement(ConsentSelector, { onSelectionChange: handleSelectionChange, selectedValue: selection })))),
        React.createElement(Collapse, { in: isOpen },
            React.createElement(Box, { sx: {
                    border: '1px solid #E5E7EB',
                    borderTop: 'none',
                    borderRadius: '0 0 8px 8px',
                    padding: '16px',
                    backgroundColor: 'white',
                } },
                React.createElement(Box, { sx: { color: '#666', fontSize: '14px' } },
                    selection === 'no-consent' && React.createElement(RpmNoConsentLayout, null),
                    selection === 'opt-in' &&
                        React.createElement(RpmOptInLayout, { patient: patient, allRequiredChecks: props.onRpmRequiredChecks, optIn: patient.rpmConsent, consentMethod: consentMethod, consentDate: consentDate, consentNotes: consentNotes, onFormDataChange: handleFormDataChange }),
                    selection === 'opt-out' &&
                        React.createElement(RpmOptOutLayout, { optOut: (!patient.rpmConsent && (patient.rpmConsentedAt !== null && patient.rpmConsentedAt !== '')), isNoConsent: !patient.rpmConsent && (patient.rpmConsentedAt === null || patient.rpmConsentedAt === ''), patient: patient, allRequiredChecks: props.onRpmRequiredChecks, optOutReason: optOutReason, optOutDate: optOutDate, optOutNotes: optOutNotes, onFormDataChange: handleFormDataChange }))))));
};
